import { render } from "./ProductSummaryCard.vue?vue&type=template&id=00cf3c99&scoped=true"
import script from "./ProductSummaryCard.vue?vue&type=script&lang=js"
export * from "./ProductSummaryCard.vue?vue&type=script&lang=js"

import "./ProductSummaryCard.vue?vue&type=style&index=0&id=00cf3c99&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cf3c99"]])

export default __exports__